import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export class NoopAction implements Action {
  readonly type = 'Noop';
}

export class RouterNavigateAction implements Action {
  static ROUTER_NAVIGATE = '[Router] Navigate';
  readonly type = RouterNavigateAction.ROUTER_NAVIGATE;
  constructor(public options: { url: string[] | string, extras?: NavigationExtras }) { }
}

export class RefreshPageAction implements Action {
  static REFRESH_PAGE = '[Router] Refresh';
  readonly type = RefreshPageAction.REFRESH_PAGE;
}